import { render, staticRenderFns } from "./NieuwsmakerVoteSlide.vue?vue&type=template&id=54eec1f3"
import script from "./NieuwsmakerVoteSlide.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerVoteSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54eec1f3')) {
      api.createRecord('54eec1f3', component.options)
    } else {
      api.reload('54eec1f3', component.options)
    }
    module.hot.accept("./NieuwsmakerVoteSlide.vue?vue&type=template&id=54eec1f3", function () {
      api.rerender('54eec1f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/NieuwsmakerVoteSlide.vue"
export default component.exports